<template>
  <v-form v-model="formvalid" @submit.prevent="login">
    <v-container id="login" class="fill-height" tag="section">
      <v-row justify="center">
        <v-slide-y-transition appear>
          <base-material-card color="success" light max-width="100%" width="400" class="px-5 py-3">
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">Login</h1>
              </div>
            </template>

            <v-card-text class="text-center">
              <v-text-field
                v-model="form.userid"
                :rules="[rules.required]"
                color="secondary"
                label="Userid..."
                prepend-icon="mdi-face"
              />

              <v-text-field
                v-model="form.password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="show1 ? 'text' : 'password'"
                class="mb-8"
                color="secondary"
                label="Password..."
                prepend-icon="mdi-lock-outline"
                @click:append="show1 = !show1"
              />

              <pages-btn :disabled="!formvalid" type="submit" color="success">Let's Go</pages-btn>
            </v-card-text>
          </base-material-card>
        </v-slide-y-transition>
      </v-row>

      <base-material-snackbar
        v-model="alertbox.show"
        :type="alertbox.color"
        v-bind="{
          top: true,
          right: true
        }"
      >{{ alertbox.msg }}</base-material-snackbar>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "Login",

  components: {
    PagesBtn: () => import("./components/Btn")
  },
  data: () => ({
    formvalid: false,
    form: {
      userid: "",
      password: ""
    },
    show1: false,
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match"
    },
    alertbox: {
      show: false,
      msg: "",
      color: "error"
    }
  }),
  methods: {
    login() {
      const redirect = this.$auth.redirect();
      this.$auth.login({
        data: this.form,
        error(res) {
          this.alertbox.show = true;
          this.alertbox.msg = "The userid and password you entered don't match";
        },
        redirect: redirect ? redirect.from.path : "/",
        fetchUser: true
      });
    }
  }
};
</script>
